module.exports = __webpack_public_path__ + "img/background-landing.3bdb85e3.jpg";